import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ChevronRight } from "lucide-react";
import kobi from "../../assets/images/KUUL TRANS ROUND.png";

const PRIMARY = "#00A2F8";

type KobikuulBannerProps = {
  /** Tighter layout for the main layout header (desktop). */
  compact?: boolean;
  className?: string;
};

export default function KobikuulBanner({
  compact,
  className = "",
}: KobikuulBannerProps) {
  const avatarSize = compact ? "h-10 w-10" : "h-12 w-12";
  const ringSize = compact ? "h-12 w-12" : "h-14 w-14";
  const titleClass = compact
    ? "text-sm font-bold text-slate-800"
    : "text-base font-bold text-slate-800";
  const subtitleClass = compact
    ? "text-xs text-slate-500 leading-snug"
    : "text-[13px] text-slate-500 leading-snug";

  return (
    <Link
      to="/main/chat"
      aria-label="Open Kobikuul AI chat"
      className={[
        "flex min-w-0 box-border w-full max-w-md items-center rounded-2xl border border-slate-200 bg-gradient-to-br from-slate-50 via-slate-100 to-slate-200 shadow-[0_4px_12px_rgba(0,162,248,0.08)] transition-shadow hover:shadow-md max-[369px]:gap-1.5 max-[369px]:px-2 max-[369px]:py-2",
        compact ? "gap-2 px-3 py-2" : "gap-3 px-4 py-3.5",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="relative mr-0.5 max-[369px]:mr-0 shrink-0">
        <div
          className={`absolute ${ringSize} -left-1 -top-1 max-[369px]:h-11 max-[369px]:w-11 max-[369px]:-left-0.5 max-[369px]:-top-0.5 rounded-full bg-[#00A2F8]/40 animate-pulse`}
          aria-hidden
        />
        <div
          className={`relative overflow-hidden rounded-full bg-white shadow ${avatarSize} max-[369px]:!h-9 max-[369px]:!w-9`}
        >
          <img src={kobi} alt="" className="h-full w-full object-cover" />
        </div>
        <span
          className="absolute bottom-0 right-0 h-3.5 w-3.5 max-[369px]:h-3 max-[369px]:w-3 rounded-full border-2 border-white bg-green-500"
          aria-hidden
        />
      </div>

      <div className="min-w-0 flex-1 overflow-hidden">
        <div className="mb-0.5 flex flex-wrap items-center gap-2 max-[369px]:gap-1">
          <span
            className={`${titleClass} max-[369px]:text-xs max-[369px]:leading-tight`}
          >
            Kobikuul AI
          </span>
          <span
            className="inline-flex items-center gap-1 rounded-xl bg-sky-100 px-2 py-0.5 text-[11px] font-semibold max-[369px]:px-1.5 max-[369px]:text-[10px]"
            style={{ color: PRIMARY }}
          >
            <Sparkles
              className="h-2.5 w-2.5 max-[369px]:h-2 max-[369px]:w-2 shrink-0"
              strokeWidth={2.5}
            />
            Online
          </span>
        </div>
        <p
          className={`${subtitleClass} max-[369px]:text-[11px] max-[369px]:leading-snug`}
        >
          Ask me anything about health &amp; wellness
        </p>
      </div>

      <div
        className="flex h-8 w-8 max-[369px]:h-7 max-[369px]:w-7 shrink-0 items-center justify-center rounded-full bg-white shadow-sm text-slate-400 group-hover:text-slate-500"
        aria-hidden
      >
        <ChevronRight
          className="h-5 w-5 max-[369px]:h-4 max-[369px]:w-4"
          strokeWidth={2}
        />
      </div>
    </Link>
  );
}
